var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07221 1.35564C6.63559 0.381454 8.04194 0.381455 8.60532 1.35564L13.8528 10.4294C14.4169 11.4048 13.713 12.625 12.5863 12.625L2.09127 12.625C0.964499 12.625 0.260622 11.4048 0.82471 10.4294L6.07221 1.35564Z",
    stroke: "#D70015",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83872 9.575C7.83872 9.82353 7.63725 10.025 7.38872 10.025C7.14019 10.025 6.93872 9.82353 6.93872 9.575C6.93872 9.32647 7.14019 9.125 7.38872 9.125C7.63725 9.125 7.83872 9.32647 7.83872 9.575Z",
    fill: "#D70015",
    stroke: "#D70015",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38879 4.43164V7.125",
    stroke: "#D70015",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRed);
export default __webpack_public_path__ + "static/media/alert-red.f37b45d87102b20c81ad9b53425f040d.svg";
export { ForwardRef as ReactComponent };